<template>
  <v-container fluid>
    <section class='header'>
      <h5>CONTACT</h5>
      <h2>I'd Love To Hear From You</h2>
    </section>

    <div class='contact-wrapper'>
      <div>
        <div class='icon-wrapper text-center'>
          <v-icon color='#ebebeb'>mdi-email-outline</v-icon>
        </div>
        <p class='primary-txt text-center email'>EMAIL ME AT</p>
        <p class='paragraph text-center'>dom.barga@gmail.com</p>
      </div>

      <div class='copyright text-center'>
        <div class='icons-wrapper'>
          <div>
            <v-btn icon large href='https://github.com/dombrga' target='_blank'>
              <v-icon color='#ebebeb'>mdi-github</v-icon>
            </v-btn>
          </div>
          <div>
            <v-btn icon large href='https://www.linkedin.com/in/dominic-barga/' target='_blank'>
              <v-icon color='#ebebeb'>mdi-linkedin</v-icon>
            </v-btn>
          </div>
        </div>
        <div>
          &copy; Copyright 2021 | DOM
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {

}
</script>

<style scoped>
/* typography */
* {
  font-family: var(--poppins);
}

p { margin: 0;}
.primary-txt { color: var(--primary); }

h2 {
  color: #ffffff;
  font-size: 1.9rem;
  line-height: 1.8rem;
}

.email {
  font-size: 1rem;
  font-weight: 900;
}

.paragraph {
  color: var(--paragraph);
}



/* layout */
.container {
  background-color: #151515;
  padding: 90px 20px 20px;
}

.header {
  margin-bottom: 50px;
}

.icon-wrapper >>> .v-icon {
  font-size: 1.8rem;
}

.copyright {
  color: var(--paragraph);
  font-size: .9rem;
  margin-top: 3rem;
}


.icons-wrapper {
  display: flex;
  justify-content: center;
  column-gap: .5rem;
}


@media (min-width: 900px) {
  .copyright {
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 7rem;
  }

  .icons-wrapper {
    order: 2;
  }
}

</style>